import React, { useEffect, useState, useCallback } from "react";
import { View, Text, ActivityIndicator } from "react-native";
import { useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { getPlayerMatchMapping } from "../redux/actions/userMatchMappingAction";

import { STORE_MATCH_STRING } from "../redux/actions/types";
import {
  SetVideoControl,
  UpdateVideoTime,
  SeekVideoTo,
  ClearSeekFlag,
  FetchMatchStringFromServer,
} from "../redux/actions/controlAction";
import InputBoard from "./InputBoard";
import InputBoardCoordinates from "./InputBoardCoordinates";
import InputBoardNew from "./InputBoardNew";
import InputBoardNewEvents from "./InputBoardNewEvents";
import { useAbly } from "ably/react";
import { subscribeToMatchChannel, unsubscribeFromMatchChannel } from "../utils/ablyManager";
import { benchmarkService } from "../utils/benchmarkService";
import BenchmarkPanel from "../components/BenchmarkPanel";
import { isAblyVideoSyncEnabled } from "../persistence/firestore/ablyVideoSyncConfig";

const Analyse = (props) => {
  const [selectedMatchData, setSelectedMatchData] = useState(false);
  const [analysisData, setAnalysisData] = useState(false);
  const [systemType, setSystemType] = useState(1);
  const [useAblyVideoSync, setUseAblyVideoSync] = useState(false);
  // Server string fetch on entry: "loading" | "ok" | "failed".
  const [stringFetch, setStringFetch] = useState("loading");
  // InputBoard (default) and InputBoardCoordinates (5) wait for the server string.
  const gatesOnServerString = systemType !== 2 && systemType !== 3;
  const { matchId } = useParams();
  let history = useHistory();
  const {
    videoControl,
    videoTime,
    SetVideoControl,
    SeekVideoTo,
    ClearSeekFlag,
    analystId,
    token,
    analysedString,
  } = props;

useEffect(() => {
  if (!matchId) return;

  subscribeToMatchChannel(matchId, (msg) => {
    if (msg.name === "match-string-updated") {
      console.log("Match updated → refreshing Analyse");
      props.FetchMatchStringFromServer(matchId, analystId, token);
    }
  });

  return () => {
    unsubscribeFromMatchChannel(matchId);
  };
}, [matchId, analystId, token]);

  const initialHandleUserKeyPress = useCallback(
    (event) => {
      const { key, keyCode } = event;

      if (keyCode === 32) {
        SetVideoControl(!videoControl);
      }
      if (keyCode === 39) {
        SeekVideoTo(parseFloat(videoTime + 5));
      }
      if (keyCode === 37) {
        SeekVideoTo(parseFloat(videoTime - 5));
      }
    },
    [SeekVideoTo, SetVideoControl, videoControl, videoTime]
  );

  useEffect(() => {
    window.addEventListener("keydown", initialHandleUserKeyPress);
    window.addEventListener("keyup", (e) => ClearSeekFlag());
    return () => {
      window.removeEventListener("keydown", initialHandleUserKeyPress);
      window.removeEventListener("keyup", (e) => ClearSeekFlag());
    };
  }, [ClearSeekFlag, initialHandleUserKeyPress]);

  useEffect(() => {
    if (!matchId || !analystId || !token) return;
    let cancelled = false;
    setStringFetch("loading");
    props.FetchMatchStringFromServer(matchId, analystId, token).then((ok) => {
      if (!cancelled) setStringFetch(ok ? "ok" : "failed");
    });
    return () => {
      cancelled = true;
    };
  }, [matchId, analystId, token, props.FetchMatchStringFromServer]);

  // Tagging on top of a string the server didn't confirm can overwrite newer
  // work from another device, so the analyst is sent back instead.
  useEffect(() => {
    if (stringFetch !== "failed" || !gatesOnServerString) return;
    window.alert(
      "Could not load the match string from the server.\n\n" +
        "Check your internet connection and open the match again. " +
        "Tagging is blocked so an old copy on this device can't overwrite saved work."
    );
    if (history.length > 1) history.goBack();
    else history.replace("/");
  }, [stringFetch, gatesOnServerString, history]);

  useEffect(() => {
    if (!props.isAuthenticated) {
      history.push("/login");
    }
  }, [history, props.isAuthenticated]);

  useEffect(() => {
    if (matchId && props.all_matches) {
      let allMatches = props.all_matches;
      let matchData = allMatches.find((i) => {
        return i.id.toString() === matchId;
      });

      setSelectedMatchData(matchData);
      if (matchData?.is_new_coordinate_system) {
        setSystemType(2);
      } else {
        setSystemType(matchData?.analysis_setup);
      }

      // Start benchmark session — always-on, no flags required.
      // benchmarkService.startSession({
      //   matchId,
      //   analystId: props.analystId,
      //   syncMode: !!matchData?.use_ably_video_sync,
      // });

      props.GetPlayerMatchMapping(
        matchId,
        matchData?.team_a_details?.id,
        matchData?.team_b_details?.id
      );
    } else {
      history.replace("/");
    }
  }, [props.all_matches, matchId, props.all_matches, history]);

  // Ably video-sync is controlled remotely from Firestore (appConfig/ablyVideoSync),
  // not from the per-match field. Mode "all" enables every match; "matches"
  // enables only the configured matchIds.
  useEffect(() => {
    if (!matchId) return;
    let cancelled = false;
    isAblyVideoSyncEnabled(matchId).then((enabled) => {
      if (!cancelled) setUseAblyVideoSync(enabled);
    });
    return () => {
      cancelled = true;
    };
  }, [matchId]);

  useEffect(() => {
    if (selectedMatchData) {
      const analysedata = {
        TeamInput: [
          {
            team_id: selectedMatchData.team_a_details.id,
            team_details: props.team_a_data || [],
          },
          {
            team_id: selectedMatchData.team_b_details.id,
            team_details: props.team_b_data || [],
          },
        ],
      };
      setAnalysisData(analysedata);
      console.log(analysedata, "CHHH");
    }
  }, [selectedMatchData, props.team_a_data, props.team_b_data]);

  // const storeMatchStringAndRedirect = (matchString) => {
  //   props.SaveMatchString(matchString);
  //   history.push(`/analyse-preview/${matchId}`);
  // };

  console.log("Rendering Analyse with → ", {
    selectedMatchData,
    analysisData,
    systemType,
    useAblyVideoSync,
  });

  if (analysisData && gatesOnServerString && stringFetch !== "ok") {
    return (
      <View style={styles.gate}>
        {stringFetch === "loading" && <ActivityIndicator size="large" />}
        <Text style={styles.gateText}>
          {stringFetch === "loading"
            ? "Loading the match string from the server…"
            : "Could not load the match string from the server."}
        </Text>
      </View>
    );
  }

  return (
    <div style={styles.container}>
      {/* Benchmark FAB — always visible once a match session is active, works on mobile */}
      <BenchmarkPanel />

      {/* key={matchId}: remount the board on match change so the previous
          match's in-memory string is never saved under the new matchId. */}
      {analysisData &&
        (systemType === 3 ? (
          <InputBoardNewEvents
            // storeMatchString={storeMatchStringAndRedirect}
            key={matchId}
            analysedata={analysisData}
          />
        ) : systemType === 2 ? (
          <InputBoardNew
            // storeMatchString={storeMatchStringAndRedirect}
            key={matchId}
            analysedata={analysisData}
          />
        ) : systemType === 5 ? (
          <InputBoardCoordinates
            // storeMatchString={storeMatchStringAndRedirect}
            key={matchId}
            analysedata={analysisData}
            useAblyVideoSync={useAblyVideoSync}
          />
        ) : (
          <InputBoard
            // storeMatchString={storeMatchStringAndRedirect}
            key={matchId}
            analysedata={analysisData}
            useAblyVideoSync={useAblyVideoSync}
          />
        ))}
    </div>
  );
};

const styles = {
  container: {
    flex: 1,
    width: "100%",
    height: "100%",
    backgroundColor: "var(--app-bg)",
    alignItems: "center",
  },
  gate: {
    flex: 1,
    width: "100%",
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    backgroundColor: "var(--app-bg)",
  },
  gateText: {
    fontSize: 14,
    color: "var(--text-1)",
  },
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    login_error: state.auth.login_error,
    loading: state.auth.loading,
    m_error_msg: state.match.m_error_msg,
    analystId: state.auth.analyst_id,
    all_matches: state.match.all_matches,
    team_a_data: state.userMatchMapping.team_a_mapping,
    team_b_data: state.userMatchMapping.team_b_mapping,
    team_a_mapping_error: state.userMatchMapping.team_a_mapping_error,
    team_b_mapping_error: state.userMatchMapping.team_b_mapping_error,
    videoControl: state.control.videoControl,
    videoTime: state.control.videoTime,
    token: state.auth.token,
    analysedString: state.control.analysedString,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ClearSeekFlag: () => {
      dispatch(ClearSeekFlag());
    },
    SeekVideoTo: (t) => {
      dispatch(SeekVideoTo(t));
    },
    UpdateVideoTime: (t) => {
      dispatch(UpdateVideoTime(t));
    },
    SetVideoControl: (c) => {
      dispatch(SetVideoControl(c));
    },
    GetPlayerMatchMapping: (matchId, teamAId, teamBId, token) => {
      dispatch(getPlayerMatchMapping(matchId, teamAId, teamBId, token));
    },
    FetchMatchStringFromServer: (matchId, analystId, token) =>
      dispatch(FetchMatchStringFromServer(matchId, analystId, token)),

    SaveMatchString: (match_string) => {
      dispatch({
        type: STORE_MATCH_STRING,
        payload: match_string,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Analyse);
